import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../component-base';
import { AuthService } from '../../services/authentication/auth.service';
import { CurrentUserService } from '../../services/current-user.service';
import { CacheService } from '../../services/cashe-service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login-type',
  templateUrl: './login-type.component.html',
  styleUrls: ['./login-type.component.css']
})
export class LoginTypeComponent extends BaseComponent implements OnInit {
  loginByCompany: any = false;
  agancy: any;
  constructor(public authService: AuthService,
    public override currentUserService: CurrentUserService,
    public override translate?: TranslateService,
    public router?: Router
  ) {
    super();
  }

  UserId : string;
  ngOnInit() {
    this.UserId = CacheService.getUserId();
    this.showLoader = true;

  }

  selectLogin() {
    CacheService.setCompanyLogin(String(this.loginByCompany));
    if (this.loginByCompany == "true")
      this.router.navigateByUrl(`auth/cr-number`);
    else {
      this.selectAgancy();
    }
  }

  selectAgancy() {
    CacheService.setCompanyLogin(String(this.loginByCompany));
    if (this.loginByCompany == "false" || !this.loginByCompany) {
      var id = CacheService.getUsername();
      
      this.showLoader = true;
      this.currentUserService.GetAgancyInfoAsync(id).subscribe(res => {
        if (!res || !res.Agency) {
          this.showLoader = false;
          this.info('shared.userNotRegisteredParty');
          return;
        }

        this.agancy = res.Agency;

        this.agancy.AgencyCode = res.Agency.Agency_Code;
        this.agancy.name = res.Agency.name;
        this.agancy.userId = this.UserId;
        CacheService.setAgancy(this.agancy.name + ' - ' + this.agancy.AgencyCode);
        this.saveAgancy();
      })
    }
  }


  saveAgancy() {
    CacheService.setCompanyLogin(String(this.loginByCompany));

    this.currentUserService.SaveAgancy(this.agancy).subscribe(res => {
      CacheService.setLoginStatus("Active");
      var d = res;
      this.router.navigateByUrl("/");
    })
  }



}

